import * as React from 'react';

import type { Modules } from 'bundles/front-page/hooks/usePageContentQuery';
import HeroBannerModuleRenderer from 'bundles/front-page/redesign-modules/hero-banner/HeroBannerModuleRenderer';

type Props = {
  modules: Modules;
};

const FrontPageModulesRenderer = ({ modules }: Props) => {
  return (
    <>
      {/* TODO: Add logic to render LOHP modules */}
      {modules.map((module) => {
        switch (module.__typename) {
          case 'HeroBentoModule':
            return <HeroBannerModuleRenderer key={module.sys.id} content={module} />;
          default:
            return null;
        }
      })}
    </>
  );
};

export default FrontPageModulesRenderer;
